import React from "react";
import TraguardiSportivi from "../Clienti/TraguardiSportivi";

// Tab «Traguardi» della scheda del junior: tutto in TraguardiSportivi, uguale per il player
const TraguardiJunior = (props) => <TraguardiSportivi userId={props.profile?.junior?.userId} />;

export default TraguardiJunior;
